import { memo } from 'react';
import { useSelector } from 'react-redux';

import { ViewTypeName } from '@air/api/types';
import { useBreakpointsContext } from '@air/provider-media-query';

import { ViewSortingMenu } from '~/components/ViewControls/ViewSortingMenu/ViewSortingMenu';
import { useClearSearchSortOverrideWhenQueryCleared } from '~/hooks/search/useClearSearchSortOverrideWhenQueryCleared';
import { currentViewTypeNameSelector } from '~/store/configViews/selectors';

export type ShowcaseHeaderViewControlsProps = {
  visibilityToggleMenu: React.ReactNode;
};

export const ShowcaseHeaderViewControls = memo(({ visibilityToggleMenu }: ShowcaseHeaderViewControlsProps) => {
  useClearSearchSortOverrideWhenQueryCleared();
  const currentViewTypeName = useSelector(currentViewTypeNameSelector);
  const inGalleryView = currentViewTypeName === ViewTypeName.gallery;
  const { isAboveMediumScreen } = useBreakpointsContext();

  return (
    <div className="flex items-center gap-2">
      {isAboveMediumScreen && inGalleryView && <ViewSortingMenu />}
      {visibilityToggleMenu}
      {/* TODO: Add ViewTypeToggleMenu when further views are implemented
      - Table View (https://linear.app/air/issue/REV-877/public-collection-landing-page-add-support-for-table-view)
      - Kanban View (https://linear.app/air/issue/REV-878/public-collection-landing-page-add-support-for-kanban-view) */}
    </div>
  );
});

ShowcaseHeaderViewControls.displayName = 'ShowcaseHeaderViewControls';
